import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-historic-home',
  templateUrl: './historic-home.component.html',
  styleUrls: ['./historic-home.component.css']
})
export class HistoricHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
